import { api } from "@/lib/api";
import { trackLead } from "@/lib/tracking";
import { getAttribution, trackStep } from "@/lib/traffic";
import { SIMULATORS } from "@/config/simulators";
import { fmtEur } from "@/lib/format";

const PERIOD_SUFFIX = { mensuelle: " / mois", trimestrielle: " / trimestre", annuelle: " / an" };
const CONV_KEYS = {
  "louer-vendre": "louer-vendre",
  "coloc-simple": "colocation",
  "cash-flow": "cash-flow",
  "tri-rendement": "rentabilite",
};

export const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const formatInput = (f, v, periode) => {
  const base = f.suffix === "€" ? fmtEur(v) : `${String(v).replace(".", ",")} ${f.suffix || ""}`.trim();
  return base + (f.period ? PERIOD_SUFFIX[periode] || "" : "");
};

const buildSaisies = (slug, inputs = {}) =>
  (SIMULATORS[slug]?.steps || []).flatMap((s) =>
    s.fields
      .filter((f) => inputs[f.key] !== undefined && inputs[f.key] !== null)
      .map((f) => ({ label: f.label, value: formatInput(f, inputs[f.key], inputs[`${f.key}Periode`]) }))
  );

export const LEAD_FIELD_ERRORS = {
  prenom: "Prénom obligatoire",
  nom: "Nom obligatoire",
  email: "Adresse email invalide",
  telephone: "Numéro de téléphone invalide",
  consentement: "Merci de cocher la case de consentement",
  simulateur: "Simulation introuvable, merci de la relancer",
};

// Renvoie la liste des champs en erreur d'une réponse 422, ou null
export const errorFields = (e) => {
  const detail = e?.response?.data?.detail;
  if (e?.response?.status !== 422 || !Array.isArray(detail)) return null;
  return [...new Set(detail.map((d) => d.loc?.[d.loc.length - 1]))];
};

export const errorText = (fields) => {
  if (!fields) return "L'envoi a échoué. Réessayez.";
  const msgs = fields.map((f) => LEAD_FIELD_ERRORS[f]).filter(Boolean);
  return msgs.length ? msgs.join(" · ") : "Merci de vérifier vos informations.";
};

// Envoi du lead + mesure serveur + conversions Google Ads / Meta (une fois par simulation)
export const submitLead = async (endpoint, form, sim) => {
  const { utm_source = "", utm_content = "", gclid = "", fbclid = "", device = "" } = getAttribution();
  const res = await api.post(endpoint, {
    utm_source, utm_content, gclid, fbclid, device,
    ...form,
    simulateur: sim.slug || "",
    resume: sessionStorage.getItem("assertimmo_resume") || "",
    inputs: sim.inputs || {},
    resultat: sim.resultat || {},
    hypotheses: {
      saisies: buildSaisies(sim.slug, sim.inputs),
      texte: sessionStorage.getItem("assertimmo_hypotheses") || "",
    },
  });
  if (sim.slug) trackStep(sim.slug, "lead", { telephone_fourni: form.telephone.trim() ? "oui" : "non" });
  if (sessionStorage.getItem("assertimmo_tracked") !== "yes") {
    if (CONV_KEYS[sim.slug]) trackLead(CONV_KEYS[sim.slug]);
    sessionStorage.setItem("assertimmo_tracked", "yes");
  }
  return res.data;
};
